//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { SalesBadDebt } from '../../graphql/entities';
import Formatters from '../../components/grid-addons/formatters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { Direction } from '../../graphql/schema/p4types';
import { ModalFormatter } from '../../components/grid-addons/formatters/ModalFormatter';

const LazyCustomerForm = React.lazy(() => import('../../views/customer/CustomerForm'));

const SALES_BAD_DEBT_COLUMN_OVERRIDES = {
  documentNumber: {
    name: 'Number',
    key: 'documentNumber',
    width: 100,
  },
  documentDate: {
    name: 'Date',
    key: 'documentDate',
    formatter: 'date',
    width: 110,
  },
  documentStatus: {
    name: 'Status',
    width: 80,
    formatter: Formatters.DocumentStatusFormatter,
  },
  writeOffTotal: {
    name: 'Write Off Total',
    width: 130,
    formatter: Formatters.NumericFormatter,
  },
  vatTotal: {
    name: 'VAT Reclaim',
    width: 130,
    formatter: Formatters.NumericFormatter,
  },
  'customer.name': {
    name: 'Customer Name',
  },
  'customer.reference': {
    name: 'Customer',
    formatter: ModalFormatter,
    width: 125,
    options: {
      modalContent: LazyCustomerForm,
      modalProps: { forceReadOnly: true },
      entityId: 'customer.id',
    },
  },
};

const SALES_BAD_DEBT_FIELD_NAMES = [
  'documentNumber',
  'documentDate',
  'documentStatus',
  'customer.reference',
  'customer.name',
  'documentReference',
  'writeOffTotal',
  'vatTotal',
];

const { readOnlyStatus, formUrl, type, title, workspace } = SalesBadDebt;

const SalesBadDebtWorkspace = (props) => {
  const workspaceProps = useWorkspace(props, SalesBadDebt, {
    columns: SALES_BAD_DEBT_FIELD_NAMES,
    columnOverrides: SALES_BAD_DEBT_COLUMN_OVERRIDES,
    initialSortColumn: 'documentNumber',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={type}
      formUrl={formUrl}
      title={title}
      defaultQuery={workspace}
      readOnlyStatus={readOnlyStatus}
      {...workspaceProps}
      {...props}
      entity={SalesBadDebt}
    />
  );
};

export default SalesBadDebtWorkspace;
